import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import ChannelGridRowContent from '../ChannelGridRowContent/ChannelGridRowContent';
import { useContext } from 'react';
import { ChannelContext } from '@/contexts/channel.context';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';

import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';

type Props = {
  playlist: any;
  featured?: boolean;
  swipeEnabled?: boolean;
};

const ChannelGridRow: React.FC<Props> = ({
  playlist,
  featured,
  swipeEnabled,
}: Props) => {
  const { mainPlaylist, nowPlaying } = useContext(ChannelContext);
  const [swipper, setSwipper] = useState<any>();
  const [showPrevButton, setShowPrevButton] = useState<boolean>(false);
  const [showNextButton, setShowNextButton] = useState<boolean>(true);

  useEffect(() => {
    if (swipper && mainPlaylist) {
      const index = mainPlaylist.contents.findIndex(
        (content) => content._id === nowPlaying?._id,
      );
      swipper.slideTo(index);
    }
  }, [swipper, mainPlaylist, nowPlaying]);

  const movePrevSlide = useCallback(
    (evt) => {
      evt.stopPropagation();
      swipper.slidePrev();
      setShowPrevButton(!swipper.isBeginning);
      setShowNextButton(!swipper.isEnd);
    },
    [swipper],
  );

  const moveNextSlide = useCallback(
    (evt) => {
      evt.stopPropagation();
      swipper.slideNext();
      setShowPrevButton(!swipper.isBeginning);
      setShowPrevButton(!swipper.isEnd);
    },
    [swipper],
  );

  return (
    <div
      className={`rounded-xl px-4 md:px-8 items-center relative w-full
      ${featured ? 'bg-orange py-6' : 'bg-transparent py-2'}
      `}
    >
      {playlist.channel_logo && (
        <div className="absolute top-0 flex justify-start items-center h-full">
          <Image
            className="rounded-md overflow-hidden"
            layout="fixed"
            height={featured ? 60 : 55}
            width={featured ? 60 : 55}
            objectFit="contain"
            priority
            quality={90}
            src={playlist.channel_logo.url}
            alt="Live channel"
          />
        </div>
      )}
      <div className={`pl-[70px] ${featured ? 'pl-[82px]' : 'h-[55px]'}`}>
        <Swiper
          breakpoints={{
            0: {
              slidesPerView: 1,
              // spaceBetween: 10,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          }}
          className="h-full"
          navigation={{
            nextEl: 'channel-swipper-button-next',
            prevEl: 'channel-swipper-button-prev',
            disabledClass: 'swipper-navigation-disabled',
          }}
          onSwiper={(swipper) => setSwipper(swipper)}
          simulateTouch={swipeEnabled}
        >
          {playlist.contents.map((content, index) => (
            <SwiperSlide
              key={index}
              className={
                featured
                  ? 'border-r-2 last-of-type:border-0 border-black border-opacity-5'
                  : ''
              }
            >
              <ChannelGridRowContent
                featured={featured}
                content={{ ...content, playlist }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {playlist.channel_type !== 'live_channel' && (
        <div
          className={`hidden lg:flex absolute h-10 w-18 items-center z-40 right-2
          ${featured ? 'bottom-0.5' : 'space-x-2 top-[20%]'}
        `}
        >
          {showPrevButton ? (
            <button
              className={` ${
                featured
                  ? 'text-black p-0.5'
                  : 'bg-white bg-opacity-10 rounded-lg p-2'
              }`}
              onClick={movePrevSlide}
            >
              <ChevronLeftIcon className="w-6" />
            </button>
          ) : (
            <div className="w-10" />
          )}
          {showNextButton ? (
            <button
              className={` ${
                featured
                  ? 'text-black p-0.5'
                  : 'bg-white bg-opacity-10 rounded-lg p-2'
              }`}
              onClick={moveNextSlide}
            >
              <ChevronRightIcon className="w-6" />
            </button>
          ) : (
            <div className="w-10" />
          )}
        </div>
      )}
    </div>
  );
};

export default ChannelGridRow;
